import { type FC } from 'react';
import { FormField, MaskedTextInputCompact, Text, usePriceMask } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { useField, useFormInstance } from '@adv-frontend/form-kit';
import { MIN_AVAILABLE_PRICE, RUBBLE_SIGN } from '../../../../lib/constants';
import { changeVariantPriceTooltipForm } from '../../model';
import { useIsMinimalPriceGreaterThanPrice } from '../../model/hooks/useIsMinimalPriceGreaterThanPrice';

type MinimalPriceFieldProps = { formId: string; isSaving: boolean } & TestProps;

export const MinimalPriceField: FC<MinimalPriceFieldProps> = ({
    formId,
    'data-testid': dataTestId = 'MinimalPriceField',
    isSaving,
}) => {
    const formInstance = useFormInstance({ form: changeVariantPriceTooltipForm, id: formId });

    const priceMaskConfig = usePriceMask({
        currencyText: RUBBLE_SIGN,
        min: MIN_AVAILABLE_PRICE,
        precision: 0,
    });
    const field = useField(formInstance.fields.minimalPrice);
    const fieldProps = field.getProps();
    const isMinimalPriceGreaterThanPrice = useIsMinimalPriceGreaterThanPrice(formId);

    return (
        <div>
            <FormField
                data-testid={dataTestId}
                description={
                    isMinimalPriceGreaterThanPrice ? (
                        <Text color="orange" data-testid={`${dataTestId}.Description`}>
                            Минимальная цена выше, чем цена до скидки
                        </Text>
                    ) : undefined
                }
            >
                {(formFields) => (
                    <MaskedTextInputCompact
                        {...formFields}
                        {...fieldProps}
                        maskConfig={priceMaskConfig}
                        isLoading={isSaving}
                        label="Минимальная цена"
                        min={MIN_AVAILABLE_PRICE}
                        data-testid={`${dataTestId}.TextInput`}
                        size="xs"
                    />
                )}
            </FormField>
        </div>
    );
};
